import { render } from "./VideoGalleryEditPage.vue?vue&type=template&id=6a2f03d5&scoped=true"
import script from "./VideoGalleryEditPage.vue?vue&type=script&lang=js"
export * from "./VideoGalleryEditPage.vue?vue&type=script&lang=js"

import "./VideoGalleryEditPage.vue?vue&type=style&index=0&id=6a2f03d5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2f03d5"]])

export default __exports__